module.exports = __webpack_public_path__ + "static/img/6196_phase_function_Paper_Points.e3a5f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6196_phase_function_Paper_Points.png
// module id = z2vY
// module chunks = 0